import { render, staticRenderFns } from "./TrainingData.vue?vue&type=template&id=6d0c29ec&scoped=true"
import script from "./TrainingData.vue?vue&type=script&lang=js"
export * from "./TrainingData.vue?vue&type=script&lang=js"
import style0 from "./TrainingData.vue?vue&type=style&index=0&id=6d0c29ec&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0c29ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d0c29ec')) {
      api.createRecord('6d0c29ec', component.options)
    } else {
      api.reload('6d0c29ec', component.options)
    }
    module.hot.accept("./TrainingData.vue?vue&type=template&id=6d0c29ec&scoped=true", function () {
      api.rerender('6d0c29ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/components/athetes/TrainingData.vue"
export default component.exports